import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';


const sanitise = (task) => ({
    ...task,
    name: task.name || `${task.service}::${task.method}`
});

const normalize = (data) => {
    const result = [], tasks = {};
    data.forEach(task => {
        const { id } = task;
        result.push(id);
        tasks[id] = sanitise(task);
    });
    return {result, tasks};
};

class SystemTaskStore extends ReduceStore {

    isFetching() {
        return this.getState().isFetching;
    }

    getAll() {
        const state = this.getState();
        return state.taskIds.map(id => state.tasks[id]);
    }

    getTask(id) {
        return this.getState().tasks[id];
    }

    getInitialState() {
        return {isFetching: false, tasks: {}, taskIds: []};
    }

    reduce(state, action) {
        let idList;
        switch (action.type) {
            case ActionTypes.SYSTEM_TASK_LIST_REQUEST:
                return update(this.getState(), { isFetching: { $set: true }});

            case ActionTypes.SYSTEM_TASK_LIST_SUCCESS:
                const { result, tasks } = normalize(action.data);
                return update(this.getState(), {
                    isFetching: { $set: false },
                    tasks: { $merge: tasks },
                    taskIds: { $set: result }
                });

            case ActionTypes.SYSTEM_TASK_LIST_FAILURE:
                return update(this.getState(), { isFetching: { $set: false }});

            case ActionTypes.SYSTEM_TASK_INFO_REQUEST:
                return update(this.getState(), { isFetching: { $set: true }});

            case ActionTypes.SYSTEM_TASK_INFO_SUCCESS:
                idList = (this._state.taskIds.includes(action.payload.id) ? [] : [action.payload.id]);
                return update(this.getState(), {
                    isFetching: { $set: false },
                    tasks: {[action.payload.id]: { $set: sanitise(action.data) }},
                    taskIds: { $push: idList },
                });

            case ActionTypes.SYSTEM_TASK_INFO_FAILURE:
                idList = this._state.taskIds.filter(id => id !== action.payload.id);
                return update(this.getState(), {
                    isFetching: { $set: false },
                    taskIds: { $set: idList }
                });

            default:
                return state;
        }
    }
    
}

export default new SystemTaskStore(CentricDispatcher);
